import { render } from "./EditMediaGallery.vue?vue&type=template&id=654c7f07&scoped=true"
import script from "./EditMediaGallery.vue?vue&type=script&lang=js"
export * from "./EditMediaGallery.vue?vue&type=script&lang=js"

import "./EditMediaGallery.vue?vue&type=style&index=0&id=654c7f07&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654c7f07"]])

export default __exports__